import React, { useEffect, useRef, useState } from 'react';
import {VehicleBrandsScreen} from './vehicle-brands/ui/screens/VehicleBrandsScreen';
export default function VehicleBrandConfiguration() {

    return (
        <div>
           <VehicleBrandsScreen></VehicleBrandsScreen>
        </div>
    );
}